module.exports = __webpack_public_path__ + "img/superman.d733210b.png";